import React from "react";
import { Link } from "react-router-dom";

function PhotosVideos() {

  return (

    <main className="homepage media-page public-section-landing">

      <h1 style={{ textAlign: "center" }}>
        Media
      </h1>

      <p
        style={{
          textAlign: "center",
          color: "#666",
          marginBottom: "40px",
          fontSize: "18px"
        }}
      >
        Browse photos, videos and Chatra Sanglap.
      </p>

      <div className="article-category-grid">

        <Link
          to="/photos-videos/photos"
          className="publication-card"
        >
          <div className="landing-category-icon" aria-hidden="true">
  📷
</div>
<h2>Photos</h2>

          <p>
            Browse image galleries and photographs.
          </p>

        </Link>

        <Link
          to="/photos-videos/videos"
          className="publication-card"
        >
          <div className="landing-category-icon" aria-hidden="true">
  🎥
</div>
<h2>Videos</h2>

          <p>
            Watch videos and media coverage.
          </p>

        </Link>

        <Link
  to="/photos-videos/chatra-sanglap"
  className="publication-card"
>
  <div
    className="landing-category-icon"
    aria-hidden="true"
  >
    🎙️
  </div>

  <h2>
    Chatra Sanglap
  </h2>

  <p>
    Watch conversations, interviews and discussions.
  </p>

</Link>

      </div>

    </main>

  );

}

export default PhotosVideos;